import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "tv-cast-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "tvCastModalTitle"
}
const _hoisted_2 = { class: "tv-cast-modal__panel" }
const _hoisted_3 = { class: "tv-cast-waiting" }
const _hoisted_4 = { class: "tv-card" }
const _hoisted_5 = { class: "tv-card-frame" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "tv-card" }
const _hoisted_8 = { class: "tv-card-frame" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "tv-batch-gallery" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "tv-batch-card-compare" }
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "tv-batch-card-meta" }
const _hoisted_16 = {
  key: 0,
  class: "tv-batch-card-name"
}
const _hoisted_17 = {
  class: "tv-split-compare",
  "aria-hidden": "false"
}
const _hoisted_18 = {
  ref: "splitViewRef",
  class: "tv-split-compare-view"
}
const _hoisted_19 = {
  ref: "splitBarRef",
  class: "tv-split-compare-bar",
  role: "separator",
  "aria-orientation": "vertical",
  "aria-label": "拖动对照原图与效果图"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "tv-cast-modal__fetch-spinner",
  "aria-hidden": "true"
}
const _hoisted_22 = { class: "tv-batch-lightbox__header" }
const _hoisted_23 = {
  key: 0,
  class: "tv-batch-lightbox-name"
}
const _hoisted_24 = { class: "tv-lightbox-mode" }
const _hoisted_25 = {
  class: "tv-lightbox-mode__capsule",
  role: "tablist",
  "aria-label": "查看模式"
}
const _hoisted_26 = ["aria-selected"]
const _hoisted_27 = ["aria-selected"]
const _hoisted_28 = { class: "tv-batch-lightbox-body" }
const _hoisted_29 = { class: "tv-split-compare-hint tv-batch-lightbox-hint" }
const _hoisted_30 = {
  ref: "lightboxSplitBarRef",
  class: "tv-split-compare-bar",
  role: "separator",
  "aria-orientation": "vertical",
  "aria-label": "拖动对照原图与效果图"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "tv-cast-modal__close",
        "aria-label": "关闭",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _cache[7] || (_cache[7] = [
        _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
      ])),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "tv-cast-modal__header" }, [
        _createElementVNode("h3", {
          class: "tv-cast-modal__title",
          id: "tvCastModalTitle"
        }, "一键投屏")
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["tv-cast-modal__body", { 'is-split-mode': _ctx.showSplitCompare, 'is-batch-mode': _ctx.isBatchMode }])
      }, [
        _withDirectives(_createElementVNode("p", _hoisted_3, "等待投屏中....", 512), [
          [_vShow, !_ctx.hasProjected]
        ]),
        _withDirectives(_createElementVNode("button", {
          type: "button",
          class: "tv-compare tv-compare-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLightbox(_ctx.singleWork)))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "tv-card-label" }, "原图线稿", -1)),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.singleWork.original)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.singleWork.original,
                    alt: "原图线稿"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "tv-card-label" }, "上色效果图", -1)),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.singleWork.result)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.singleWork.result,
                    alt: "上色效果图"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "tv-single-tip" }, "点击查看大图", -1))
        ], 512), [
          [_vShow, _ctx.showSingleCompare]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validWorks, (item, idx) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `${item.studentName}-${idx}`,
              type: "button",
              class: "tv-batch-card",
              onClick: ($event: any) => (_ctx.openLightbox(item))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  class: "tv-batch-card-compare__result",
                  src: item.result,
                  alt: `${item.studentName}效果图`
                }, null, 8, _hoisted_13),
                _createElementVNode("img", {
                  class: "tv-batch-card-compare__original",
                  src: item.original,
                  alt: `${item.studentName}原图`
                }, null, 8, _hoisted_14),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "tv-batch-card-compare__label tv-batch-card-compare__label--left" }, "原图", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "tv-batch-card-compare__label tv-batch-card-compare__label--right" }, "效果图", -1))
              ]),
              _createElementVNode("div", _hoisted_15, [
                (item.studentName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.studentName), 1))
                  : _createCommentVNode("", true),
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "tv-batch-card-tip" }, "点击查看大图", -1))
              ])
            ], 8, _hoisted_11))
          }), 128))
        ], 512), [
          [_vShow, _ctx.showBatchGallery]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_17, [
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "tv-split-compare-hint" }, "左侧为原图线稿，右侧为上色效果图；拖动中间竖线对照", -1)),
          _createElementVNode("div", _hoisted_18, [
            _cache[14] || (_cache[14] = _createElementVNode("canvas", {
              class: "tv-split-compare-canvas",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", _hoisted_19, null, 512)
          ], 512)
        ], 512), [
          [_vShow, _ctx.showSplitCompare]
        ])
      ], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["tv-cast-modal__fetch", { 'is-loading': _ctx.fetchLoading }]),
        disabled: _ctx.fetchLoading,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleManualFetch && _ctx.handleManualFetch(...args)))
      }, [
        (_ctx.fetchLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_21))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.fetchLoading ? '获取中...' : '手动获取'), 1)
      ], 10, _hoisted_20)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", {
        class: "tv-batch-lightbox",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "学员作品大图",
        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_22, [
          (_ctx.lightboxWork.studentName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.lightboxWork.studentName), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "tv-lightbox-mode__label" }, "查看模式", -1)),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["tv-lightbox-mode__option", { 'is-active': _ctx.lightboxViewMode === 'split' }]),
                role: "tab",
                "aria-selected": _ctx.lightboxViewMode === 'split',
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLightboxViewMode('split')))
              }, " 分屏模式 ", 10, _hoisted_26),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["tv-lightbox-mode__option", { 'is-active': _ctx.lightboxViewMode === 'compare' }]),
                role: "tab",
                "aria-selected": _ctx.lightboxViewMode === 'compare',
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLightboxViewMode('compare')))
              }, " 对照模式 ", 10, _hoisted_27),
              _createElementVNode("span", {
                class: _normalizeClass(["tv-lightbox-mode__indicator", { 'is-compare': _ctx.lightboxViewMode === 'compare' }]),
                "aria-hidden": "true"
              }, null, 2)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "tv-batch-lightbox-close",
            "aria-label": "关闭大图",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeLightbox && _ctx.closeLightbox(...args)))
          }, _cache[18] || (_cache[18] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.lightboxHint), 1),
          _createElementVNode("div", {
            ref: "lightboxSplitViewRef",
            class: _normalizeClass(["tv-split-compare-view tv-split-compare-view--fullscreen", { 'is-split-screen': _ctx.lightboxViewMode === 'split' }])
          }, [
            _cache[19] || (_cache[19] = _createElementVNode("canvas", {
              class: "tv-split-compare-canvas",
              "aria-hidden": "true"
            }, null, -1)),
            _withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [
              [_vShow, _ctx.lightboxViewMode === 'compare']
            ])
          ], 2)
        ])
      ], 512), [
        [_vShow, _ctx.lightboxVisible]
      ])
    ]))
  ], 512)), [
    [_vShow, _ctx.visible]
  ])
}